import InvestorCouponsError from './InvestorCouponsError';
class PropertyWithInsufficientBricks extends InvestorCouponsError {
    constructor(options) {
        super('The property has not sufficient bricks to sale', options);
    }
}
export default PropertyWithInsufficientBricks;
